import ReportingForm from './ReportingForm';

export default ReportingForm;